module.exports = __webpack_public_path__ + "img/tianjin.a02b7bfd.jpg";